<ion-content class="ion-no-padding" *ngIf="(serviceBasedSections && quoteData) || voucherData">
  <form class="lead-form model-container" [formGroup]="voucherForm">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue" *ngIf="!editVoucherId">Converting Quote For
          {{leadDetails?.firstName}} {{leadDetails?.lastName}}</ion-title>
        <ion-title class="text-start ion-no-padding title-blue" *ngIf="editVoucherId">Edit Voucher For
          {{leadDetails?.firstName}} {{leadDetails?.lastName}}</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button class="filled-blue-btn" type="button" (click)="onSubmit()">Save</ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>


    <div class="navigationpart-parent">
      <div class="d-flex gap-3 ps-3 navigationpart nav">
        <a id="link-accomadation" (click)="scrollTo('accomadation')" class="navlist active"
          *ngIf="serviceBasedSections.showHotels">Accommodation</a>
        <a id="link-transportation" (click)="scrollTo('transportation')" class="navlist"
          *ngIf="voucherTypeVisibility.transportationVoucher">Transportation</a>
        <a id="link-transfers" (click)="scrollTo('transfers')" class="navlist"
          *ngIf="!serviceBasedSections.showTransportation && serviceBasedSections.showTransfers">Transfers</a>
        <a id="link-routeDetails" (click)="scrollTo('routeDetails')" class="navlist"
          *ngIf="serviceBasedSections.showRouteCraft">Sightseeing</a>
        <a id="link-iAndE" (click)="scrollTo('iAndE')" class="navlist">I&Es</a>
        <a id="link-tAndC" (click)="scrollTo('tAndC')" class="navlist">T&Cs</a>
        <a id="link-cancellation" (click)="scrollTo('cancellation')" class="navlist">CPs</a>
        <a id="link-important" (click)="scrollTo('important')" class="navlist">Imp Info</a>
        <a id="link-notes" (click)="scrollTo('notes')" class="navlist">Notes</a>
      </div>
    </div>

    <div class="model-content">
      <!-- Accomodation voucher section -->
      <div class="main-section" *ngIf="serviceBasedSections.showHotels">
        <div class="main-container">
          <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1" id="accomadation">
            <ion-title class="dark-title-sm ion-no-padding">Hotel Details</ion-title>
            <div>
              <div class="currency-container position-relative">
                <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                  formControlName="showHotels"></ion-toggle>
                <p class="toggle-tooltip" [ngClass]="voucherForm.get('showHotels')?.value ? 'green': 'red'">
                  {{voucherForm.get('showHotels')?.value ? 'This section will be
                  displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
              </div>
            </div>
          </div>

          <div *ngIf="voucherForm.get('showHotels')?.value">
            <div formArrayName="accommodations" class="px-1">
              <div class="single-destination-container" *ngFor="let destination of destinationFormArray().controls; let destIndex = index" [formGroupName]="destIndex">
                <div class="">
                  <p class="destination-name"><b>Destination</b> {{destination.get("destination")?.value}}</p>
                </div>
                <div formArrayName="locations">
                  <div class="single-accommodation-container" *ngFor="let accommodation of locationFormArray(destIndex).controls; let locationIndex = index" [formGroupName]="locationIndex">
                    <div class="row">
                      <div class="col-5">
                        <div class="input-container d-flex align-items-center">
                          <h2 class="location-title fs-6 me-3">Location</h2>
                          <div class="location-input-container"
                            [ngClass]="{ 'invalid-input': accommodation.get('locationName')?.invalid && accommodation.get('locationName')?.touched }">
                            <app-locations-autocomplete formControlName="locationName"></app-locations-autocomplete>
                          </div>
                        </div>
                      </div>
                      <div class="col-7">
                      </div>
                    </div>

                     <div formArrayName="hotels">
                        <div *ngFor="let hotel of hotelsFormArray(destIndex, locationIndex).controls; let hotelIndex = index" [formGroupName]="hotelIndex">
                          <div class="row">
                            <div class="col-4" style="width: 254px;">
                              <div class="input-container">
                                <label for="" class="label">Hotel Name*</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('hotelName')?.invalid && hotel.get('hotelName')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'hotelName') }">
                                  <input class="input-text input" type="text" placeholder="Hotel name"
                                    formControlName="hotelName">
                                </div>
                              </div>
                            </div>

                            <div class="col-2 date-time-width">
                              <div class="input-container">
                                <label for="" class="label">Hotel Category*</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('hotelType')?.invalid && hotel.get('hotelType')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'hotelType')  }">
                                  <select class="input" formControlName="hotelType">
                                    <option value="" hidden>select</option>
                                    <option *ngFor="let item of accommodationType" [value]="item.name">{{item.name}}</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div class="col-2 date-time-width">
                              <div class="input-container">
                                <label for="" class="label">Room Category*</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('roomCategory')?.invalid && hotel.get('roomCategory')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'roomCategory')  }">
                                  <app-dropdown-select [dropdownValues]="roomCategory"
                                    formControlName="roomCategory"></app-dropdown-select>
                                </div>
                              </div>
                            </div>

                            <div class="col">
                              <div class="input-container">
                                <label for="" class="label">Rooms*</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('totalRooms')?.invalid && hotel.get('totalRooms')?.touched, 'empty-field': isFieldZeroInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'totalRooms')  }">
                                  <app-increment-number-input formControlName="totalRooms"></app-increment-number-input>
                                </div>
                              </div>
                            </div>


                          </div>

                          <div class="row">
                            <div class="date-time-width">
                              <div class="input-container">
                                <label for="" class="label">Check-in Date*</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('checkIn')?.invalid && hotel.get('checkIn')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'checkIn')  }">
                                  <app-date-picker [minDate]="today" formControlName="checkIn"></app-date-picker>
                                </div>
                              </div>
                            </div>
                            <div class="col-2 date-time-width">
                              <div class="input-container">
                                <div>
                                  <label for="" class="label">Check-in Time</label>
                                  <app-time-picker formControlName="checkInTime"></app-time-picker>
                                </div>
                              </div>
                            </div>
                            <div class="date-time-width">
                              <div class="input-container">
                                <label for="" class="label">Check-Out Date*</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('checkOut')?.invalid && hotel.get('checkOut')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'checkOut')  }">
                                  <app-date-picker [minDate]="today" formControlName="checkOut"></app-date-picker>
                                </div>
                              </div>
                            </div>
                            <div class="col-2 date-time-width">
                              <div class="input-container">
                                <div>
                                  <label for="" class="label">Check-out Time</label>
                                  <app-time-picker formControlName="checkOutTime"></app-time-picker>
                                </div>
                              </div>
                            </div>

                            <div class="col">
                              <div class="input-container">
                                <label for="" class="label">Meal Plan</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('typesOfMeals')?.invalid && hotel.get('typesOfMeals')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'mealPlan')  }">
                                  <app-meal-plan-input [items]="meals" [selectAllKey]="MEAL_PLAN.ALL_INCLUSION"
                                    formControlName="mealPlan"></app-meal-plan-input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-2 date-time-width">
                              <div class="input-container">
                                <label for="" class="label">Extra Beds</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('extraBeds')?.invalid && hotel.get('extraBeds')?.touched }">
                                  <app-increment-number-input formControlName="extraBeds"></app-increment-number-input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-6">
                              <div class="input-container">
                                <label for="" class="label">Hotel Full Address</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('hotelFullAddress')?.invalid && hotel.get('hotelFullAddress')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'hotelFullAddress')  }">
                                  <input type="text" class="input" formControlName="hotelFullAddress"
                                    placeholder="place, state, county with code" [appMaxLength]="100">
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="input-container">
                                <label for="" class="label">Booking ID*</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('bookingId')?.invalid && hotel.get('bookingId')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'bookingId')  }">
                                  <input type="text" class="input" formControlName="bookingId" placeholder="Ex- 98876669dc867"
                                    [appMaxLength]="50">
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-6">
                              <div class="input-container">
                                <label for="" class="label">Guest Name*</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('guestName')?.invalid && hotel.get('guestName')?.touched, 'empty-field': isFieldEmptyInArray(hotelsFormArray(destIndex, locationIndex), hotelIndex, 'guestName')  }">
                                  <input type="text" class="input" formControlName="guestName"
                                    placeholder="Guest name used for booking" [appMaxLength]="50">
                                </div>
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="input-container">
                                <label for="" class="label">No of Adults</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('adults')?.invalid && hotel.get('adults')?.touched }">
                                  <input type="text" class="input" formControlName="adults">
                                </div>
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="input-container">
                                <label for="" class="label">No of Children</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('childrens')?.invalid && hotel.get('childrens')?.touched }">
                                  <input type="text" class="input" formControlName="childrens">
                                </div>
                              </div>
                            </div>
                            <div class="col-3">
                              <div class="input-container">
                                <label for="" class="label">No of Infants</label>
                                <div
                                  [ngClass]="{ 'invalid-input': hotel.get('infants')?.invalid && hotel.get('infants')?.touched }">
                                  <input type="text" class="input" formControlName="infants">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Hotel terms and condtions -->
            <div class="hotel-terms-conditions" *ngIf="voucherForm.get('accommodationsTermsAndConditions')?.value?.length">
              <div class="ion-no-padding mb-1">
                <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Hotel Terms &
                  Conditions</ion-title>
              </div>
              <div class="ion-padding-horizontal">
                <div class="row">
                  <div class="col">
                    <div class="input-container">
                      <app-selectable-list-items 
                        [addButtonText]="'Add Hotel Terms & Conditions'"
                        formControlName="accommodationsTermsAndConditions"
                        [showDefaultActionButton]="true"
                      ></app-selectable-list-items>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Hotel terms end -->
            <div class="row" class="ion-padding-horizontal">
              <div class="col">
                <div class="input-container">
                  <label for="" class="label">Accommodation Notes</label>
                  <div
                    [ngClass]="{ 'invalid-input': voucherForm.get('accommodationNotes')?.invalid && voucherForm.get('accommodationNotes')?.touched, 'empty-field': isFieldEmptyInForm('accommodationNotes') }">
                    <app-text-formatting-input formControlName="accommodationNotes"></app-text-formatting-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="ion-padding-horizontal mb-1">
              <div class="input-container">
                <label for="hotel-acknowledgement" class="acknowledgement-label"><input type="checkbox"
                    id="hotel-acknowledgement" class="me-1" formControlName="hotelsAck">I acknowledge that the above
                  hotels information is correct to the best of my knowledge.</label>
                <p class="warning-message mb-0" *ngIf="voucherForm.get('hotelsAck')?.invalid">Please acknowledge the
                  details to continue.</p>
              </div>
            </div>
          </div>

        </div>
      </div>


      <!-- Accomodatipon voucher section end -->

      <!-- Transporation section -->

      <div class="main-section" *ngIf="voucherTypeVisibility.transportationVoucher">
        <div class="main-container">
          <div>
            <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1"
              id="transportation">
              <ion-title class="dark-title-sm ion-no-padding">Transportation Details</ion-title>
              <div>
                <div class="currency-container position-relative">
                  <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                    formControlName="showTransportation"></ion-toggle>
                  <p class="toggle-tooltip" [ngClass]="voucherForm.get('showTransportation')?.value ? 'green': 'red'">
                    {{voucherForm.get('showTransportation')?.value ? 'This section will be
                    displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
                </div>
              </div>
            </div>

            <div class="ion-padding-horizontal" *ngIf="voucherForm.get('showTransportation')?.value">
              <div formArrayName="transportations">
                <div *ngFor="let transport of transportations.controls; let i = index" [formGroupName]="i"
                  class="single-accommodation-container">
                  <div class="row">
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">Type*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('type')?.invalid && transport.get('type')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'type')  }">
                          <input type="text" class="input text-capitalize" formControlName="type">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">
                      <div class="input-container">
                        <label for="" class="label">Travel Name*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('name')?.invalid && transport.get('name')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'name')  }">
                          <input placeholder="Travel's Name" class="input-text input" type="text"
                            formControlName="name">
                        </div>
                      </div>
                    </div>


                    <div class="col-2">
                      <div class="input-container">
                        <label class="label">Departure Date*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('departureDate')?.invalid && transport.get('departureDate')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'departureDate')   }">
                          <app-date-picker [minDate]="today" formControlName="departureDate"></app-date-picker>
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label class="label">Departure Time*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('departureTime')?.invalid && transport.get('departureTime')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'departureTime')   }">
                          <app-time-picker formControlName="departureTime"></app-time-picker>
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label class="label">Arrival Date*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('arrivalDate')?.invalid && transport.get('arrivalDate')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'arrivalDate')   }">
                          <app-date-picker [minDate]="convertToDate(transport.get('departureDate')?.value)"
                            formControlName="arrivalDate"></app-date-picker>
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label class="label">Arrival Time*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('arrivalTime')?.invalid && transport.get('arrivalTime')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'arrivalTime')   }">
                          <app-time-picker formControlName="arrivalTime"></app-time-picker>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row gap-1">
                    <div class="col">
                      <div class="input-container">
                        <label for="" class="label">Departure Station*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('departure')?.invalid && transport.get('departure')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'departure')  }">
                          <app-locations-autocomplete formControlName="departure"></app-locations-autocomplete>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="input-container">
                        <label for="" class="label">Arrival Station*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('arrival')?.invalid && transport.get('arrival')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'arrival')  }">
                          <app-locations-autocomplete formControlName="arrival"></app-locations-autocomplete>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Booking details table -->
                  <div class="mt-2">
                    <div *ngIf="bookingDetailsFortransport(i).invalid && bookingDetailsFortransport(i).touched"
                      class="text-danger" style="font-size: 12px;">
                      Please fill out all required fields in the booking details.
                    </div>

                    <table class="table table-bordered invoice-items-table">
                      <thead>
                        <tr>
                          <th class="sm-column">S.no</th>
                          <!-- <th style="width: 30%;">Guest Name*</th> -->
                          <th style="width: 20%;">First Name*</th>
                          <th style="width: 20%;">Last Name</th>
                          <th style="width: 30%;">Booking ID*</th>
                          <th style="width: 30%;">PNR Number</th>
                          <!-- <th></th> -->
                        </tr>
                      </thead>
                      <tbody formArrayName="bookingDetails">
                        <tr *ngFor="let item of bookingDetailsFortransport(i).controls; let bookingIndex = index"
                          [formGroupName]="bookingIndex">
                          <td class="p-1">{{bookingIndex + 1}}</td>
                          <td
                            [ngClass]="{'empty-field': isFieldBookingDetailsCellEmpty(transportations, i, 'bookingDetails', bookingIndex, 'firstName')}">
                            <input type="text" class="table-input" formControlName="firstName" [appMaxLength]="50"
                              (blur)="handleFirstNameChangeInTransport($event, bookingIndex)">
                          </td>
                          <td
                            [ngClass]="{'empty-field': isFieldBookingDetailsCellEmpty(transportations, i, 'bookingDetails', bookingIndex, 'lastName')}">
                            <input type="text" class="table-input" formControlName="lastName" [appMaxLength]="50"
                              (blur)="handleLastNameChangeInTransport($event, bookingIndex)">
                          </td>
                          <td
                            [ngClass]="{'empty-field': isFieldBookingDetailsCellEmpty(transportations, i, 'bookingDetails', bookingIndex, 'bookingId')}">
                            <input type="text" class="table-input" formControlName="bookingId" [appMaxLength]="20"
                              (blur)="handleBookingIdChangeInTransport($event, i, bookingIndex)">
                          </td>
                          <td
                            [ngClass]="{'empty-field': isFieldBookingDetailsCellEmpty(transportations, i, 'bookingDetails', bookingIndex, 'pnrNumber')}">
                            <input type="text" class="table-input" formControlName="pnrNumber" [appMaxLength]="30"
                              (blur)="handlePnrNumberChangeInTransport($event, i, bookingIndex)">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--  -->

                  <div class="row">
                    <div class="col-6">
                      <div class="input-container">
                        <label for="" class="label">Cabin Baggage</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('cabinBaggage')?.invalid && transport.get('cabinBaggage')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'cabinBaggage')  }">
                          <input type="text" formControlName="cabinBaggage" class="input" [appMaxLength]="30"
                            placeholder="Cabin baggage">
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="input-container">
                        <label for="" class="label">Check-in Baggage</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('checkinBaggage')?.invalid && transport.get('checkinBaggage')?.touched, 'empty-field': isFieldEmptyInArray(transportations, i, 'checkinBaggage')  }">
                          <input type="text" formControlName="checkinBaggage" class="input" [appMaxLength]="30"
                            placeholder="Check-in baggage">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">No of Adults</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('adults')?.invalid && transport.get('adults')?.touched }">
                          <input type="text" class="input" formControlName="adults">
                        </div>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">No of Children</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('childrens')?.invalid && transport.get('childrens')?.touched }">
                          <input type="text" class="input" formControlName="childrens">
                        </div>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">No of Infants</label>
                        <div
                          [ngClass]="{ 'invalid-input': transport.get('infants')?.invalid && transport.get('infants')?.touched }">
                          <input type="text" class="input" formControlName="infants">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="input-container">
                    <label for="" class="label">Transportation Notes</label>
                    <div
                      [ngClass]="{ 'invalid-input': voucherForm.get('transportationNotes')?.invalid && voucherForm.get('transportationNotes')?.touched, 'empty-field': isFieldEmptyInForm('transportationNotes')  }">
                      <app-text-formatting-input formControlName="transportationNotes"></app-text-formatting-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-1">
                <div class="input-container">
                  <label for="transport-acknowledgement" class="acknowledgement-label"><input type="checkbox"
                      id="transport-acknowledgement" class="me-1" formControlName="transfersAck">I acknowledge that the
                    above
                    transportation information is correct to the best of my knowledge.</label>
                  <p class="warning-message mb-0" *ngIf="voucherForm.get('transfersAck')?.invalid">Please acknowledge
                    the
                    details to continue.</p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>

      <!-- Transporation section end -->



      <!-- Transfers section -->

      <div class="main-section" *ngIf="!serviceBasedSections.showTransportation && serviceBasedSections.showTransfers">
        <div class="main-container">
          <div>
            <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1" id="transfers">
              <ion-title class="dark-title-sm ion-no-padding">Transfers Details</ion-title>
              <div>
                <div class="currency-container position-relative">
                  <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                    formControlName="showTransfer"></ion-toggle>
                  <p class="toggle-tooltip" [ngClass]="voucherForm.get('showTransfer')?.value ? 'green': 'red'">
                    {{voucherForm.get('showTransfer')?.value ? 'This section will be
                    displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
                </div>
              </div>
            </div>

            <div class="ion-padding-horizontal" *ngIf="voucherForm.get('showTransfer')?.value">
              <div formArrayName="tranfersCars">
                <div *ngFor="let transfer of transfers.controls; let i = index" [formGroupName]="i"
                  class="single-accommodation-container">
                  <div class="row">
                    <div class="col">
                      <div class="w-100 d-flex justify-content-end">
                        <button type="button" class="add-more-btn" (click)="removeTransfers(i)" *ngIf="i !== 0">x
                          Remove</button>
                      </div>
                    </div>
                  </div>

                  <!-- Radio buttons -->

                  <div class="row">
                    <div class="col-4">
                      <div class="input-container">
                        <label for="" class="label">Name*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('name')?.invalid && transfer.get('name')?.touched, 'empty-field': isFieldEmptyInArray(transfers, i, 'name')  }">
                          <input placeholder="Travel's Name" class="input-text input" type="text"
                            formControlName="name">
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label class="label">Departure Date*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('departureDate')?.invalid && transfer.get('departureDate')?.touched }">
                          <app-date-picker [minDate]="today" formControlName="departureDate"></app-date-picker>
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label class="label">Departure Time*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('departureTime')?.invalid && transfer.get('departureTime')?.touched }">
                          <app-time-picker formControlName="departureTime"></app-time-picker>
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label class="label">Arrival Date*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('arrivalDate')?.invalid && transfer.get('arrivalDate')?.touched }">
                          <app-date-picker [minDate]="convertToDate(transfer.get('departureDate')?.value)"
                            formControlName="arrivalDate"></app-date-picker>
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label class="label">Arrival Time*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('arrivalTime')?.invalid && transfer.get('arrivalTime')?.touched }">
                          <app-time-picker formControlName="arrivalTime"></app-time-picker>
                        </div>
                      </div>
                    </div>


                    <!-- <div class="col-3">
                  <div class="input-container">
                    <label class="label">Departure* <span>(Date|Time) </span></label>
                    <div [ngClass]="{ 'invalid-input': transfer.get('departureTime')?.invalid && transfer.get('departureTime')?.touched, 'empty-field': isFieldEmptyInArray(transfers, i, 'departureTime')  }">
                      <app-datetime-picker formControlName="departureTime"></app-datetime-picker>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label class="label">Arrival* <span>(Date|Time) </span></label>
                    <div [ngClass]="{ 'invalid-input': transfer.get('arrivalTime')?.invalid && transfer.get('arrivalTime')?.touched, 'empty-field': isFieldEmptyInArray(transfers, i, 'arrivalTime')  }">
                      <app-datetime-picker formControlName="arrivalTime"></app-datetime-picker>
                    </div>
                  </div>
                </div> -->
                  </div>

                  <div class="row gap-1">
                    <div class="col">
                      <div class="input-container">
                        <label for="" class="label">Departure Place*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('departure')?.invalid && transfer.get('departure')?.touched, 'empty-field': isFieldEmptyInArray(transfers, i, 'departure')  }">
                          <app-locations-autocomplete formControlName="departure"></app-locations-autocomplete>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="input-container">
                        <label for="" class="label">Arrival Place*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('arrival')?.invalid && transfer.get('arrival')?.touched, 'empty-field': isFieldEmptyInArray(transfers, i, 'arrival')  }">
                          <app-locations-autocomplete formControlName="arrival"></app-locations-autocomplete>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <div class="input-container">
                        <label for="" class="label">Booking ID*</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('bookingId')?.invalid && transfer.get('bookingId')?.touched, 'empty-field': isFieldEmptyInArray(transfers, i, 'bookingId')  }">
                          <input type="text" class="input" formControlName="bookingId" placeholder="Ex- ID768998798">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <div class="input-container">
                        <label for="" class="label">Cabin Baggage</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('cabinBaggage')?.invalid && transfer.get('cabinBaggage')?.touched, 'empty-field': isFieldEmptyInArray(transfers, i, 'cabinBaggage')  }">
                          <input type="text" formControlName="cabinBaggage" class="input" [appMaxLength]="30"
                            placeholder="Cabin baggage">
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label for="" class="label">No of Adults</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('adults')?.invalid && transfer.get('adults')?.touched }">
                          <input type="text" class="input" formControlName="adults">
                        </div>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="input-container">
                        <label for="" class="label">No of Children</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('childrens')?.invalid && transfer.get('childrens')?.touched }">
                          <input type="text" class="input" formControlName="childrens">
                        </div>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="input-container">
                        <label for="" class="label">No of Infants</label>
                        <div
                          [ngClass]="{ 'invalid-input': transfer.get('infants')?.invalid && transfer.get('infants')?.touched }">
                          <input type="text" class="input" formControlName="infants">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="input-container">
                    <label for="" class="label">Transfers Notes</label>
                    <div
                      [ngClass]="{ 'invalid-input': voucherForm.get('transfersNotes')?.invalid && voucherForm.get('transfersNotes')?.touched, 'empty-field': isFieldEmptyInForm('transfersNotes')  }">
                      <app-text-formatting-input formControlName="transfersNotes"></app-text-formatting-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Transfers section end -->

      <!-- Sightseeting section start -->

      <div class="main-section" *ngIf="serviceBasedSections.showRouteCraft">
        <div class="main-container">
          <div>
            <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1"
              id="routeDetails">
              <ion-title class="dark-title-sm ion-no-padding">Sightseeing Details</ion-title>
              <div>
                <div class="currency-container position-relative">
                  <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                    formControlName="showSightSeeing"></ion-toggle>
                  <p class="toggle-tooltip" [ngClass]="voucherForm.get('showSightSeeing')?.value ? 'green': 'red'">
                    {{voucherForm.get('showSightSeeing')?.value ? 'This section will be
                    displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
                </div>
              </div>
            </div>

            <div class="ion-padding-horizontal" *ngIf="voucherForm.get('showSightSeeing')?.value">
              <div formArrayName="sightSeeingDays">
                <div *ngFor="let day of freeTextDays.controls; index as i" [formGroupName]="i"
                  class="free-text-main-container">
                  <div class="row gap-1">
                    <div class="col-2 pe-0">
                      <p class="day-title">Day {{i+1}}*</p>
                    </div>
                    <div class="col ps-0">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': day.get('day')?.invalid && day.get('day')?.touched, 'empty-field': isFieldEmptyInArray(freeTextDays, i, 'day')  }">
                          <input type="text" class="input input-text route-title" formControlName="day">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row gap-1">
                    <div class="col-2 pe-0">
                      <div class="input-container">
                        <label for="" class="label">Activities*</label>
                      </div>
                    </div>
                    <div class="col ps-0">
                      <div class="input-container">
                        <div
                          [ngClass]="{ 'invalid-input': day.get('activities')?.invalid && day.get('activities')?.touched, 'empty-field': isFieldEmptyInArray(freeTextDays, i, 'activities')  }">
                          <app-text-formatting-input formControlName="activities"></app-text-formatting-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Free text main container End -->
              <div class="row">
                <div class="col">
                  <div class="input-container">
                    <label for="" class="label">Sightseeing Notes</label>
                    <div
                      [ngClass]="{ 'invalid-input': voucherForm.get('sightSeeingNotes')?.invalid && voucherForm.get('sightSeeingNotes')?.touched, 'empty-field': isFieldEmptyInForm('sightSeeingNotes')  }">
                      <app-text-formatting-input formControlName="sightSeeingNotes"></app-text-formatting-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sightseeing section end -->


      <!-- Inclusions and exclusions -->
      <div class="main-section">
        <div class="main-container">
          <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1" id="iAndE">
            <ion-title class="dark-title-sm ion-no-padding">Inclusions & Exclusion</ion-title>
            <div>
              <div class="currency-container position-relative">
                <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                  formControlName="showInclusions"></ion-toggle>
                <p class="toggle-tooltip" [ngClass]="voucherForm.get('showInclusions')?.value ? 'green': 'red'">
                  {{voucherForm.get('showInclusions')?.value ? 'This section will be
                  displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
              </div>
            </div>
          </div>

          <div *ngIf="storedInclusionData && voucherForm.get('showInclusions')?.value" >
            <app-inclusions-and-exclusions [leadId]="clientId" [itineraryId]="quoteId"
              [storedFormData]="storedInclusionData" [generatingVoucher]="true"
              (storeFormData)="submitInclusions($event)"></app-inclusions-and-exclusions>
          </div>
        </div>
      </div>

      <!-- Inclusions and exclusions end -->


      <!-- Terms and conditoins -->

      <div class="main-section">
        <div class="main-container">
          <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1" id="tAndC">
            <ion-title class="dark-title-sm ion-no-padding">Terms & Conditions</ion-title>
            <div>
              <div class="currency-container position-relative">
                <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                  formControlName="showTerms"></ion-toggle>
                <p class="toggle-tooltip" [ngClass]="voucherForm.get('showTerms')?.value ? 'green': 'red'">
                  {{voucherForm.get('showTerms')?.value ? 'This section will be
                  displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
              </div>
            </div>
          </div>

          <div *ngIf="storedTerms && voucherForm.get('showTerms')?.value">
            <app-terms-and-conditions [leadId]="clientId" [itineraryId]="quoteId" [storedFormData]="storedTerms"
              [generatingVoucher]="true" (storeFormData)="submitTerms($event)"></app-terms-and-conditions>
          </div>
        </div>
      </div>

      <!-- Terms and conditoins end -->

      <!-- Cancellation policy -->

      <div class="main-section">
        <div class="main-container">
          <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1" id="cancellation">
            <ion-title class="dark-title-sm ion-no-padding">Cancellation Policy</ion-title>
            <div>
              <div class="currency-container position-relative">
                <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                  formControlName="showCancellation"></ion-toggle>
                <p class="toggle-tooltip" [ngClass]="voucherForm.get('showCancellation')?.value ? 'green': 'red'">
                  {{voucherForm.get('showCancellation')?.value ? 'This section will be
                  displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
              </div>
            </div>
          </div>

          <div *ngIf="storedCancellation && voucherForm.get('showCancellation')?.value">
            <app-cancellation-policy [leadId]="clientId" [itineraryId]="quoteId" [storedFormData]="storedCancellation"
              [generatingVoucher]="true" (storeFormData)="submitCancellation($event)"></app-cancellation-policy>
          </div>
        </div>
      </div>


      <!-- Cancellation policy end -->


      <!-- Importatn infomations -->
      <div class="main-section">
        <div class="main-container">
          <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1" id="important">
            <ion-title class="dark-title-sm ion-no-padding">Important Information</ion-title>
            <div>
              <div class="currency-container position-relative">
                <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                  formControlName="showImportantInfo"></ion-toggle>
                <p class="toggle-tooltip" [ngClass]="voucherForm.get('showImportantInfo')?.value ? 'green': 'red'">
                  {{voucherForm.get('showImportantInfo')?.value ? 'This section will be
                  displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
              </div>
            </div>
          </div>

          <div *ngIf="storedInformation && voucherForm.get('showImportantInfo')?.value">
            <app-important-information [leadId]="clientId" [itineraryId]="quoteId" [storedFormData]="storedInformation"
              [generatingVoucher]="true" (storeFormData)="submitImportant($event)"></app-important-information>
          </div>
        </div>
      </div>

      <!-- Importatn infomations End -->

      <!-- Voucher notes -->
      <div class="main-section">
        <div class="main-container">
          <div class="ion-padding-horizontal py-1 bg-light-gray d-flex justify-content-between mb-1" id="notes">
            <ion-title class="dark-title-sm ion-no-padding">Notes</ion-title>
            <div>
              <div class="currency-container position-relative">
                <ion-toggle [enableOnOffLabels]="true" class="section-toggle align-middle"
                  formControlName="showNotes"></ion-toggle>
                <p class="toggle-tooltip" [ngClass]="voucherForm.get('showNotes')?.value ? 'green': 'red'">
                  {{voucherForm.get('showNotes')?.value ? 'This section will be
                  displayed in the template.' : 'This section will not be displayed in the template.'}}</p>
              </div>
            </div>
          </div>

          <div class="ion-padding-horizontal" *ngIf="voucherForm.get('showNotes')?.value">
            <div>
              <div class="row">
                <div class="col-12">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('voucherNotes') }">
                      <app-text-formatting-input formControlName="voucherNotes"></app-text-formatting-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Voucher notes end -->

    </div>
  </form>


</ion-content>